import React, { useState, useEffect } from "react";
import Footer from "components/footer/Footer";
import SectionThree from "components/sectionThree/SectionThree";
import { useParams } from "react-router-dom";
import HalfArrow from "assets/images/half-arrow.svg";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "redux-store/store";
import {
  errorCleanUp,
  newPassword,
  messageCleanUp,
} from "redux-store/auth/auth.slice";
import {
  error,
  loginSuccessMessage,
  activityInProcess,
} from "redux-store/auth/auth.selector";
import { useNavigate } from "react-router-dom";

const NewPassword = () => {
  const params = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const loading = useSelector(activityInProcess);
  const [formData, setFormData] = useState({
    confirm: "",
    password: "",
  });
  const [errMessages, setMessages] = useState({
    confirmMessage: "",
    passwordMessage: "",
    matchMessage: "",
  });
  const forgotError = useSelector(error);
  const succesMessage = useSelector(loginSuccessMessage);
  useEffect(() => {
    dispatch(errorCleanUp());
    dispatch(messageCleanUp());
    if (succesMessage !== "") {
      navigate(`/`);
    }
  }, [succesMessage]);

  const onchange = (e: { target: { name: any; value: any } }) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validatePassword = (password: string) => {
    // Regular expression pattern for password validation
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;
    return passwordRegex.test(password);
  };

  const onSubmit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    const { confirm, password } = formData;
    let validConfirm = true;
    let validPass = true;
    let match = true;

    if (!validatePassword(confirm)) {
      validConfirm = false;
    }

    if (!validatePassword(password)) {
      validPass = false;
    }
    if (!(confirm === password)) {
      match = false;
    }

    setMessages({
      ...errMessages,
      confirmMessage: validConfirm
        ? ""
        : "Password must have at least 8 digits length, 1 character, 1 number",
      passwordMessage: validPass
        ? ""
        : "Password must have at least 8 digits length, 1 character, 1 number",
      matchMessage: match ? "" : "Password not matched",
    });
    if (validConfirm && validPass && match) {
      dispatch(errorCleanUp());
      if (succesMessage !== "") {
        dispatch(messageCleanUp());
      }
      let data = {
        email: params.email,
        code: params.code,
        newPassword: formData.password,
      };
      dispatch(newPassword(data));
    }
  };

  return (
    <div className="tw-w-full">
      {/* 1st main div */}
      <div className="tw-w-full">
        <SectionThree>
          <div className="tw-w-[80%] tw-mx-auto tw-bg-white tw-py-6 tw-shadow-small tw-rounded-[1.9375rem] lg:tw-w-[40%] lg:tw-rounded-[1.25rem] lg:tw-shadow-large">
            <div className="tw-w-[90%] tw-mx-auto tw-flex tw-flex-col tw-space-y-3 tw-py-4 lg:tw-w-[70%] ">
              <div>
                <span className="tw-flex-1 tw-text-[1.625rem] tw-text-black tw-font-bold lg:tw-text-[2.25rem]">
                  Create New Password
                </span>
              </div>
              <div>
                <form>
                  <div className="tw-flex tw-flex-col tw-space-y-2">
                    <div>
                      <label className="tw-text-black tw-text-[0.75rem] tw-font-normal lg:tw-text-[1rem]">
                        Enter new password
                      </label>
                    </div>

                    <div>
                      <input
                        type="password"
                        className="tw-rounded tw-w-full  tw-bg-[#FFF6F4] tw-border-[0.0625rem] tw-border-solid tw-border-[#FF9331] tw-focus:outline-none tw-text-black tw-text-[0.75rem] tw-p-1 lg:tw-p-2 lg:text-[0.875rem]"
                        placeholder="Enter new password"
                        name="password"
                        value={formData.password}
                        onChange={(e) => onchange(e)}
                      />
                      <span className=" tw-text-xs tw-text-red-500">
                        {errMessages.passwordMessage}
                      </span>
                    </div>

                    <div>
                      <input
                        type="password"
                        className="tw-rounded tw-w-full tw-bg-[#FFF6F4] tw-focus:outline-none tw-text-black tw-text-[0.75rem] tw-p-1 lg:tw-p-2 lg:text-[0.875rem]"
                        placeholder="Confirm"
                        name="confirm"
                        value={formData.confirm}
                        onChange={(e) => onchange(e)}
                      />
                      <span className=" tw-text-xs tw-text-red-500">
                        {errMessages.confirmMessage}
                      </span>
                    </div>
                  </div>
                </form>
              </div>
              <div className="tw-flex tw-items-center tw-justify-center tw-flex-col tw-gap-2">
                <span className=" tw-text-xs tw-text-red-500 tw-justify-center">
                  {errMessages.matchMessage}
                </span>
                {/* <div className="tw-flex tw-items-center tw-justify-center tw-flex-col tw-gap-2"> */}
                <span className="tw-text-xs tw-text-red-500">
                  {forgotError.message !== "" ? forgotError.message : ""}
                </span>
                <button
                  className="tw-flex tw-items-center tw-space-x-1.5 tw-mt-[0.25rem] tw-px-4 tw-py-1 tw-rounded-full tw-bg-[#FF7B6D] tw-text-white tw-text-base"
                  onClick={(e) => {
                    onSubmit(e);
                  }}
                >
                  <span className="tw-uppercase">
                    {loading ? "creating .." : "Submit"}
                  </span>
                  <img src={HalfArrow} />
                </button>
              </div>
            </div>
            {/* </div> */}
          </div>
        </SectionThree>
      </div>

      {/* 2nd main div */}
      <div className="tw-hidden lg:tw-flex">
        <Footer />
      </div>
    </div>
  );
};

export default NewPassword;
